/**
 * Customer Notification API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SystemDayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const SystemDayOfWeek = {
    NUMBER_0: 0 as SystemDayOfWeek,
    NUMBER_1: 1 as SystemDayOfWeek,
    NUMBER_2: 2 as SystemDayOfWeek,
    NUMBER_3: 3 as SystemDayOfWeek,
    NUMBER_4: 4 as SystemDayOfWeek,
    NUMBER_5: 5 as SystemDayOfWeek,
    NUMBER_6: 6 as SystemDayOfWeek
};

